import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import routes from "./routes";
import store from "./store";
import Buefy from "buefy";
// import "buefy/dist/buefy.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import moment from "moment";
import Snotify, { SnotifyPosition } from "vue-snotify";
import "vue-snotify/styles/material.css";
import Vuelidate from "vuelidate";
import Helpers from "@/services/Helpers.js";
import AsyncComputed from "vue-async-computed";
import Lightbox from "vue-my-photos";
import VueClipboard from "vue-clipboard2";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

// Register Base components globally.
const requireComponent = require.context(
  // The relative path of the components folder
  "./components",
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  );
});

Vue.config.productionTip = false;

const snotifyOptions = {
  toast: {
    position: SnotifyPosition.centerTop,
    timeout: 3000,
    bodyMaxLength: 600
  }
};

Vue.use(Snotify, snotifyOptions);

Vue.use(Buefy);

Vue.use(Vuelidate);

Vue.use(AsyncComputed);

Vue.component("lightbox", Lightbox);

Vue.use(VueClipboard);

// Filters.
Vue.filter("kb", function(value) {
  if (value) if (value.isInteger()) return Math.round(value / 1024) + "k";
});

Vue.filter("mb", function(value) {
  return Helpers.formatBytes(value, 0);
});

Vue.filter("visibility", function(value) {
  if (value) return "Hidden";
  else return "Shown";
});

Vue.filter("fromNow", function(value) {
  if (value) {
    return moment(String(value)).fromNow(false);
  }
});

Vue.filter("availableDate", function(date) {
  if (date) {
    var m1 = moment();
    var m2 = moment(date);
    var days = m2.diff(m1, "days");
    if (days <= 0) return "Available Now";
    else return "Available " + moment(String(m2)).format("MMM D, YYYY");
  }
});

Vue.filter("daysAgo", function(date1, date2) {
  if (date1 && date2) {
    var m1 = moment(String(date1));
    var m2 = moment(String(date2));
    var days = m2.diff(m1, "days");
    return days;
  }
});

Vue.filter("date", function(value) {
  if (value) {
    return moment(String(value)).format("L");
  }
});

Vue.filter("dateMedium", function(value) {
  if (value) {
    return moment(String(value)).format("MMM D, YYYY");
  }
});

Vue.filter("dateMediumTime", function(value) {
  if (value) {
    return moment(String(value)).format("MMM D, YYYY h:mm a");
  }
});

Vue.filter("time", function(value) {
  if (value) {
    return moment(String(value)).format("h:mm a");
  }
});

Vue.filter("currency", function(value, digits) {
  if (!value) value = 0;
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  });
  return formatter.format(value);
});

Vue.filter("percent", function(value, digits) {
  if (value) {
    if (value == "Infinity") return "Infinity";
    if (typeof value != "number") return "0%";
    return value.toFixed(digits) + "%";
  } else return "0%";
});

Vue.filter("number", function(value, digits) {
  if (!value) value = 0.0000000000000001;
  if (value) {
    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    });
    return formatter.format(value);
  }
});

// Global mixins.
Vue.mixin({
  methods: {
    showError(message) {
      console.log("message", JSON.stringify(message));
      let msg = "";
      if (message && message.config && message.config.crossdomain) {
        // Handle the case if a timeout occurred on the lambda service.
        console.log(
          "TCL ~ file: main.js ~ line 183 ~ showError ~ message.config.crossdomain",
          message.config.crossdomain
        );
        msg = `Service is running slow, please try again - ${message.response.status} - ${message.config.crossdomain}`;
      } else if (message && message.response && message.response.data)
        msg = message.response.data;
      else msg = message;
      this.$snotify.error(msg, {
        timeout: 5000
      });
    },
    showSuccess(message) {
      console.log("showSuccess())", message);
      this.$snotify.success(message, {
        timeout: 5000
      });
    },
    showInfo(message, timeout = 5000) {
      console.log("showInfo()", message);
      this.$snotify.info(message, {
        timeout: timeout
      });
    },
    showWarning(message) {
      console.log("showWarning()", message);
      this.$snotify.warning(message, {
        timeout: 5000
      });
    }
  }
});

// Use v-focus directive on element to focus that element.
Vue.directive("focus", {
  inserted: function(el) {
    if (el.nodeName == "INPUT") {
      el.focus();
      return;
    }
    // Find the first input inside el and focus on that.
    var input = el.getElementsByClassName("input")[0];
    if (input != undefined) input.focus();
  }
});

Vue.prototype.$log = console.log.bind(console);

new Vue({
  router,
  routes,
  store,
  render: h => h(App),
  watch: {
    $route(to, from) {
      console.log("$route watch", to.fullPath, from.fullPath);

      // Check if we are going to an evaluation page.
      if (to.fullPath.includes("evaluations"))
        this.$store.commit("SET_IS_EVALUATING", true);
      else this.$store.commit("SET_IS_EVALUATING", false);

      // Check if we are on a public page.
      if (to.public) this.$store.state.isLoginRequired = false;
      else this.$store.state.isLoginRequired = true;
    }
  }
}).$mount("#app");
